import * as actions from './NetWorthReportActions'

const initialState = {};

const NetWorthReport = (state = initialState, action) => {
    let formatted_data = {}
    switch (action.type) {
        case actions.RECEIVE_DATA:
            Object.assign(formatted_data, action.resp_data, {
                fTotalA: action.resp_data.Assets,
                fTotalB: action.resp_data.Liabilities,
                fNetTotal: action.resp_data.CurrentNetWorth,
                GroupA: action.resp_data.Assets,
                GroupB: action.resp_data.Liabilities,
                start_title: action.resp_data.NetWorth.History[0].Title,
                NetTotalInRed: (action.resp_data.CurrentNetWorth < 0),
                page: 'networthcombinedreport',
                clientId: action.clientId
            })
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    ...formatted_data,
                    is_initialized: true
                }
            })
        case actions.SET_ERRORS:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    errors: action.errors
                }
            })
        case actions.SET_RANGE:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    range: action.range
                }
            })
        default:
            return state
    }
}

export default NetWorthReport